// extracted by mini-css-extract-plugin
module.exports = {"spinner":"IconSpinner-module__spinner___3QCsY","spin":"IconSpinner-module__spin___3Egdg"};